/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MatchedFactDto { 
    /**
     * The fact path that was evaluated
     */
    factPath: string;
    /**
     * The value that the rule expected/checked for
     */
    expectedValue?: any;
    /**
     * The actual value that was provided in the args
     */
    actualValue?: any;
    /**
     * The operator used for matching
     */
    operator?: string;
    /**
     * Whether this specific condition passed (true) or failed (false)
     */
    result?: boolean;
    /**
     * Where this fact value came from
     */
    source?: MatchedFactDto.SourceEnum;
}
export namespace MatchedFactDto {
    export type SourceEnum = 'providedArgs' | 'patientContext' | 'unknown';
    export const SourceEnum = {
        ProvidedArgs: 'providedArgs' as SourceEnum,
        PatientContext: 'patientContext' as SourceEnum,
        Unknown: 'unknown' as SourceEnum
    };
}


